export const TextTypes = {
  heading1: "heading-1",
  heading2: "heading-2",
  label: "label",
  light: "light",
  link: "link",
  paragraph: "paragraph",
  signature: "signature",
  small: "small",
  subtitle: "subtitle",
};

export const TextColors = {
  black: "black",
  green: "green",
  greenV2: "greenV2",
  grey: "grey",
  navy: "navy",
  purple: "purple",
  red: "red",
  white: "white",
  yellow: "yellow",
};

export const ButtonTypes = {
  label: "label",
  primary: "primary",
  primaryOutline: "primary-outline",
  primaryOutlineV2: "primary-v2-outline",
  primaryV2: "primary-v2",
  secondary: "secondary",
  secondaryOutline: "secondary-outline",
  underline: "underline",
};

export const ButtonSizes = {
  medium: "medium",
  normal: "normal",
  small: "small",
};

export const PopoverPositions = {
  bottom: "bottom",
  left: "left",
  right: "right",
  top: "top",
};
